import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(
  (theme, { listView, isMobileMode } = {}) => ({
    editIconButton: {
      margin: isMobileMode ? '0 0 0 5px' : '10px 0 0 5px',
    },
    clickable: { cursor: 'pointer' },
    detailsColumn: { flexBasis: '75%' },
    kitDetails: {
      [theme.breakpoints.down('lg')]: {
        minHeight: 'calc(100vh - 70px - 40px)',
        display: 'flex',
        flexDirection: 'column',
      },
      [theme.breakpoints.down('md')]: {
        minHeight: 'calc(100vh - 54px - 20px)',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          minHeight: 'calc(100vh - 70px - 40px)',
          display: 'flex',
          flexDirection: 'column',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          minHeight: 'calc(100vh - 54px - 20px)',
        }),
      },
    },
    breadCrumbs: {
      color: theme.palette.darkGrey,
      ...theme.typography.h3,
      '& > * > :last-child': {
        color: theme.palette.grey2,
      },
    },
    productsLayout: listView
      ? {
          display: 'flex',
          flexDirection: 'column',
          gridTemplateColumns: 'initial',
          gap: theme.spacing(2),
        }
      : {
          display: 'grid',
          gridTemplateColumns: isMobileMode ? '1fr 1fr' : '1fr 1fr 1fr',
          gap: theme.spacing(2),
        },
    kitReorderButton: {
      marginTop: 0,
      width: '89px',
      height: '36px',
      [theme.breakpoints.down('lg')]: {
        width: '119px',
      },
      [theme.breakpoints.down('md')]: {
        width: 296,
        marginTop: '20px',
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          width: '119px',
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          width: 296,
          marginTop: '20px',
        }),
      },
    },
    kitName: {
      wordBreak: 'break-word',
    },
    productsLabel: {
      [theme.breakpoints.down('lg')]: {
        fontSize: 18,
      },
      [theme.breakpoints.down('md')]: {
        fontSize: 16,
      },
      [theme.breakpoints.downLandscape('lg')]: {
        ...(theme.isMobileDevice && {
          fontSize: 18,
        }),
      },
      [theme.breakpoints.downLandscape('md')]: {
        ...(theme.isMobileDevice && {
          fontSize: 16,
        }),
      },
    },
  }),
);
